export const youtubeId = (url = "") => {
  const match = url.match(/(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|shorts\/))([^?&/]+)/i);
  return match?.[1] || "";
};

export const vimeoEmbedUrl = (value = "") => {
  const raw = value.trim();
  if (!raw) return "";
  try {
    const url = new URL(raw.startsWith("http") ? raw : `https://${raw}`);
    if (!/(^|\.)vimeo\.com$/i.test(url.hostname)) return "";
    const id = url.pathname.match(/(?:video\/)?(\d+)(?:$|\/)/)?.[1];
    if (!id) return "";
    const hash = url.searchParams.get("h") || url.pathname.match(/\d+\/([a-f0-9]{6,})/i)?.[1];
    return `https://player.vimeo.com/video/${id}${hash ? `?h=${encodeURIComponent(hash)}` : ""}`;
  } catch {
    return "";
  }
};

export const externalEmbedUrl = (url = "") => vimeoEmbedUrl(url) || url;
